export const generatePasswordResetLink = (username) => {
  const encodedUsername = encodeURIComponent(username);
  return `/loginauth?flow=changePassword&username_or_email=${encodedUsername}&auto_invoke=true&voluntary=true`;
};
